import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { WorkflowFormFieldInputDevices } from '@workflows/types';
import { FormControl } from '@angular/forms';
import { RequestFormDevicesComponent } from '@features/requests';
import { NgClass } from '@angular/common';
import { RequestService } from '@core/services/request/request.service';

// Ключевые слова продуктов, указывающие на наличие устройств

const DEVICE_PRODUCT_KEYWORDS = [
  'x-keeper invis duos',
  'установка оборудования',
  'installation of equipment',
  'ekipman kurulumu',
  'x-keeper obd',
] as const;

@Component({
  selector: 'x-input-devices',
  imports: [RequestFormDevicesComponent, NgClass],
  templateUrl: './input-devices.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class InputDevicesComponent {
  field = input.required<WorkflowFormFieldInputDevices>();
  control = input.required<FormControl<string | null>>();
  canExecute = input<boolean>(true);

  private readonly requestService = inject(RequestService);
  readonly $request = this.requestService.$request;

  /**
   * Проверяет, есть ли в продуктах заявки устройства
   * @returns true, если в названии продукта есть ключевые слова устройств
   */
  readonly $hasDevicesInProducts = computed(() => {
    const products = this.$request().products || [];

    return products.some(product => {
      const productName = product.requestProductId.name.toLowerCase();

      return DEVICE_PRODUCT_KEYWORDS.some(keyword =>
        productName.includes(keyword),
      );
    });
  });
}
